import { matchPath } from "react-router";

import { ROUTES } from "~/constants/routing";
import type { SearchFieldVariant } from "~/feature/search/type";

export const getSearchPlaceholder = (
  pathname: string,
  variant: SearchFieldVariant = "header"
): string => {
  if (variant === "toolbar") return "Search events";

  return matchPath({ path: ROUTES.insights.path, end: false }, pathname)
    ? "Search insights…"
    : "Search markets…";
};
